import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/utils';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'glass';
  size?: 'sm' | 'md';
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'primary', size = 'md', children, ...props }, ref) => {
    const baseStyles = 'inline-flex items-center justify-center font-medium rounded-full transition-colors';
    
    const variants = {
      primary: 'bg-primary-500/20 text-primary-400 border border-primary-500/30',
      secondary: 'bg-khiimori-bg-tertiary/50 text-khiimori-text-secondary border border-khiimori-border',
      success: 'bg-success-500/20 text-success-400 border border-success-500/30',
      warning: 'bg-warning-500/20 text-warning-400 border border-warning-500/30',
      error: 'bg-error-500/20 text-error-400 border border-error-500/30',
      glass: 'bg-khiimori-bg-elevated/5 backdrop-blur-xl border border-khiimori-border/10 text-khiimori-text-primary',
    };
    
    const sizes = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-3 py-1 text-sm',
    };

    return (
      <span
        ref={ref}
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';
